const COLUMN_LIMIT = 'column_limit';
export function getColumnLimit(listSettings) {
  const result = listSettings.find(setting => setting.key == COLUMN_LIMIT);
  if (result) return result.value;
  else throw '制限の列数の設定が見つかりません。';
  ;
}
const MAXIMUM_SIZE_ATTACHMENT = 'maximum_size_attachment'
export function getMaximumSizeAttachment(listSettings) {
  const result = listSettings.find(setting => setting.key == MAXIMUM_SIZE_ATTACHMENT);
  if (result){
    if (isNaN(result.value)){
      throw '添付ファイルの最大ファイルサイズの設定に形式が間違っています。'
    }else{
      return result.value;
    }
  }
  else throw '添付ファイルの最大ファイルサイズの設定が見つかりません。';
}